import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { EnhancedSurveySubmission } from './model';

export const filterEnhancedSurveySubmissionsByMemberId = (
  submissions: EnhancedSurveySubmission[],
  memberId?: string
) =>
  memberId
    ? submissions.filter((submission) => submission.memberId === memberId)
    : [];

const getEnhancedSurveySubmissionsState = (state: RootState) =>
  state.enhancedSurveySubmissions;

export const selectEnhancedSurveySubmissions = createSelector(
  [getEnhancedSurveySubmissionsState],
  (state) => state.submissions
);

export const selectLoadingEnhancedSurveySubmissions = createSelector(
  [getEnhancedSurveySubmissionsState],
  (state) => state.loadingSubmissions
);
